"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var qs_1 = __importDefault(require("qs"));

var base_1 = __importDefault(require("../base"));

var AdminCustomerGroupsResource =
/** @class */
function (_super) {
  __extends(AdminCustomerGroupsResource, _super);

  function AdminCustomerGroupsResource() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Create a customer group.
   *
   * @param payload - customer group info
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.create = function (payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups";
    return this.client.request("POST", path, payload, {}, customHeaders);
  };
  /**
   * Retrieves a customer group.
   *
   * @param id - customer group id
   * @param query - pass query options such as "expand", "fields" etc.
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.retrieve = function (id, query, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id);

    if (query) {
      var queryString = qs_1.default.stringify(query);
      path += "?".concat(queryString);
    }

    return this.client.request("GET", path, undefined, {}, customHeaders);
  };
  /**
   * Updates a customer group
   *
   * @param id - customer group id
   * @param payload - data to update customer group with
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.update = function (id, payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id);
    return this.client.request("POST", path, payload, {}, customHeaders);
  };
  /**
   * Deletes a customer group.
   *
   * @param id - id of the customer group
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.delete = function (id, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id);
    return this.client.request("DELETE", path, undefined, {}, customHeaders);
  };
  /**
   * Lists customer groups.
   *
   * @param query optional
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.list = function (query, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups";

    if (query) {
      var queryString = qs_1.default.stringify(query);
      path = "/admin/customer-groups?".concat(queryString);
    }

    return this.client.request("GET", path, undefined, {}, customHeaders);
  };
  /**
   * Add multiple customers to a customer group.
   *
   * @param id - customer group id
   * @param payload - an object which contains an array of customer ids which will be added to the group
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.addCustomers = function (id, payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id, "/customers/batch");
    return this.client.request("POST", path, payload, {}, customHeaders);
  };
  /**
   * Remove multiple customers from a customer group.
   *
   * @param id - customer group id
   * @param payload - an object which contains an array of customers ids which will be removed from the group
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.removeCustomers = function (id, payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id, "/customers/batch");
    return this.client.request("DELETE", path, payload, {}, customHeaders);
  };
  /**
   * List and count customers that belong to provided customer groups.
   *
   * @param id - customer group id
   * @param query - params for filtering customers
   * @param customHeaders
   */


  AdminCustomerGroupsResource.prototype.listCustomers = function (id, query, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }

    var path = "/admin/customer-groups/".concat(id, "/customers");

    if (query) {
      var queryString = qs_1.default.stringify(query);
      path += "?".concat(queryString);
    }

    return this.client.request("GET", path, undefined, {}, customHeaders);
  };

  return AdminCustomerGroupsResource;
}(base_1.default);

exports.default = AdminCustomerGroupsResource;